import 'core-js/stable';
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'

// Add global fetch interceptor to automatically inject Authorization token
const originalFetch = window.fetch;
window.fetch = async function () {
  let [resource, config] = arguments;

  try {
    // Check multiple token storage locations for compatibility
    const token = localStorage.getItem('authToken') ||
      localStorage.getItem('admin_token') ||
      localStorage.getItem('kirazee_token');

    // Try to get token from user object if stored there
    let userToken = null;
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const userObj = JSON.parse(userStr);
        userToken = userObj.token;
      }
    } catch (e) { }

    const finalToken = token || userToken;

    if (finalToken) {
      if (!config) config = {};
      if (!config.headers) config.headers = {};

      // If headers is a Headers object
      if (config.headers instanceof Headers) {
        if (!config.headers.has('Authorization')) {
          config.headers.set('Authorization', `Bearer ${finalToken}`);
        }
      }
      // If headers is an array
      else if (Array.isArray(config.headers)) {
        const hasAuth = config.headers.some(h => h[0].toLowerCase() === 'authorization');
        if (!hasAuth) {
          config.headers.push(['Authorization', `Bearer ${finalToken}`]);
        }
      }
      // If headers is a plain object
      else {
        const headerKeys = Object.keys(config.headers).map(k => k.toLowerCase());
        if (!headerKeys.includes('authorization')) {
          config.headers['Authorization'] = `Bearer ${finalToken}`;
        }
      }
    }
  } catch (e) {
    console.warn('Global fetch interceptor error:', e);
  }

  return originalFetch.apply(this, [resource, config]);
};

// Filter out browser extension errors in development
if (import.meta.env.DEV) {
  window.addEventListener('error', (event) => {
    // Ignore errors from browser extensions
    if (event.filename && (
      event.filename.includes('general.js') ||
      event.filename.includes('contentScript.bundle.js') ||
      event.filename.includes('extension') ||
      event.filename.includes('chrome-extension') ||
      event.filename.includes('moz-extension')
    )) {
      event.preventDefault()
      return false
    }
  })

  window.addEventListener('unhandledrejection', (event) => {
    // Ignore promise rejections from browser extensions
    if (event.reason && typeof event.reason === 'object' && event.reason.message) {
      const message = event.reason.message
      if (message.includes('FirebaseError') &&
        (message.includes('Remote Config') || message.includes('indexedDB'))) {
        event.preventDefault()
        return false
      }
    }
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
